import { NgModule } from '@angular/core';
import { GroupByPipe } from './group-by/group-by';
@NgModule({
	declarations: [GroupByPipe],
	imports: [],
	exports: [GroupByPipe]
})
export class PipesModule { }
